import { createContext } from 'react';

import { CareConnectSettings } from 'features/care-connect-settings/hooks/care-connect-settings';

const CareConnectSettingsProviderContext = createContext<CareConnectSettings>({} as CareConnectSettings);

export default CareConnectSettingsProviderContext;
